import { requestGet, requestPost } from '@/utils/request'

export function getRSS(params){
  return requestGet('/person/rss/getRSS', params);
}

export function getRSSList(params){
  return requestPost('/person/rss/getRSSList', params);
}

export function getRSSUrlList(params){
  return requestPost('/person/rss/getRSSUrlList', params);
}
